# Base class for all collections.
module.exports = class Collection extends Backbone.Collection
    initialize: (list, options = {}) ->
        @default = options.defaultKey if options.defaultKey
        super list, options

    getDefault: ->
        @find((item)=>
            item.get('key') == @default
        )

    getDefaultIndex: ->
        @indexOf(@getDefault())



// WEBPACK FOOTER //
// ./app/models/collection.coffee